import { TuneCompSearch as Component } from './components/TuneCompSearch';
import Connector from './connector';

export const TuneCompSearch = () => <Connector component={Component} />;
